import React, { Fragment, useRef } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { SlideTransition } from '../Transition/Transition';
import { Box, Dialog, DialogContent, IconButton, useMediaQuery } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/navigation/navigation.scss';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ZoomInRoundedIcon from '@mui/icons-material/ZoomInRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import './TeamNewsDialog.scss';

SwiperCore.use([Pagination, Navigation, Autoplay]);

const NewDialogPaperStyle = {
  background: 'transparent',
  boxShadow: 'none'
};

const CloseButtonStyle = {
  position: 'absolute',
  color: '#808080',
  opacity: 0.5,
  cursor: 'pointer',
  zIndex: 1,
  background: '#ffffff50',
  padding: 0
};

const ZoomInButtonStyle = {
  position: 'absolute',
  bottom: 0,
  color: '#808080',
  background: '#ffffff50',
  padding: 0
};

const SlideButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translate(0, -50%)'
};

const TeamNewsDialog = props => {
  const { intl, userDetails, open, onClose, teamNewsUrls, ...rest } = props;

  const swiperRef = useRef(null);
  const isWide = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const onSwiper = swiper => (swiperRef.current = swiper);

  const createOnClickHandler = url => () => {
    if (url) {
      const filename = url.split(/(\\|\/)/g).pop();
      if (filename) {
        const fullVersionUrl = url.replace(filename, `full-${filename}`);
        window.open(fullVersionUrl, '_blank');
      }
    }
  };
  const isMoreThanOne = (teamNewsUrls || []).length > 1;

  const onSlideBack = event => {
    event.stopPropagation();
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const onSlideForward = event => {
    event.stopPropagation();
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  return (
    <Dialog
      className="team-news-dialog new"
      open={open}
      onClose={onClose}
      maxWidth="md"
      {...rest}
      slots={{
        transition: SlideTransition
      }}
      slotProps={{
        paper: {
          style: NewDialogPaperStyle
        }
      }}
    >
      <DialogContent className="content">
        <Swiper
          centeredSlides={true}
          autoHeight={true}
          loop={!!isMoreThanOne}
          // width={Math.min(window.innerWidth - 64, 960)}
          pagination={{
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          }}
          // navigation={{
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // }}
          autoplay={
            isMoreThanOne
              ? {
                  delay: 8000
                }
              : false
          }
          onSwiper={onSwiper}
        >
          {(teamNewsUrls || []).map((url, index) => {
            return (
              <SwiperSlide key={`${index}-${url}`}>
                <Box className="team-news-image-frame">
                  <IconButton
                    onClick={createOnClickHandler(url)}
                    style={{ ...ZoomInButtonStyle, right: isWide ? 8 : 4 }}
                    size="large"
                  >
                    <ZoomInRoundedIcon />
                  </IconButton>
                  <IconButton
                    onClick={onClose}
                    style={{
                      ...CloseButtonStyle,
                      top: isWide ? 8 : 4,
                      right: isWide ? 8 : 4
                    }}
                    size="large"
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                  <IconButton
                    color="primary"
                    onClick={onSlideBack}
                    style={{ ...SlideButtonStyle, left: isWide ? 8 : 4 }}
                    size="large"
                  >
                    <ArrowBackIosRoundedIcon />
                  </IconButton>
                  <IconButton
                    color="primary"
                    onClick={onSlideForward}
                    style={{ ...SlideButtonStyle, right: isWide ? 8 : 4 }}
                    size="large"
                  >
                    <ArrowForwardIosRoundedIcon />
                  </IconButton>

                  <img alt="team-news" src={url} />
                </Box>
              </SwiperSlide>
            );
          })}
        </Swiper>

        {isMoreThanOne && (
          <Fragment>
            <div className="swiper-pagination" />
            {/*<div className="swiper-button-next" />*/}
            {/*<div className="swiper-button-prev" />*/}
          </Fragment>
        )}
      </DialogContent>
    </Dialog>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails
  }),
  {}
)(TeamNewsDialog);

export default injectIntl(container);
